import { createFileRoute } from '@tanstack/react-router';
import { ActivityLibraryView } from '@/components/ActivityLibraryView';

export const Route = createFileRoute('/_authenticated/activity-library')({
  component: ActivityLibraryView,
});